import { render, staticRenderFns } from "./HelpTicket.vue?vue&type=template&id=816c5656&scoped=true"
import script from "./HelpTicket.vue?vue&type=script&lang=js"
export * from "./HelpTicket.vue?vue&type=script&lang=js"
import style0 from "./HelpTicket.vue?vue&type=style&index=0&id=816c5656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816c5656",
  null
  
)

export default component.exports